module.exports = __webpack_public_path__ + "static/media/cigna-logo-vector.46923c98.svg";